<template>
    <div id="editdeliveryroutepage" class="delivery-route-edit">
        <div class="top-buttons">
            <ui5-button @click="editDeliveryRoute">{{ trans('pages.edit_delivery_route.save') }}</ui5-button>
            <ui5-button @click="$router.push('/deliveryroutes')">
                {{ trans('pages.edit_delivery_route.cancel') }}
            </ui5-button>
        </div>
        <div id="editdeliveryroutefields">
            <div>
                <ui5-label>{{ trans('pages.edit_delivery_route.name_label') }}</ui5-label>
                <ui5-input
                    type="Text"
                    :value="name"
                    @input="name = $event.target.value" />
            </div>
            <div>
                <ui5-label for="description">{{ trans('pages.edit_delivery_route.description_label') }}</ui5-label>
                <ui5-input
                    type="Text"
                    :value="description"
                    @input="description = $event.target.value" />
            </div>
        </div>
        <delivery-route-config-rules v-if="configRules" v-model="configRules" />
    </div>
</template>
<style>
#editdeliveryroutepage ui5-label {
    width: 100px;
}
</style>
<script>
import DeliveryRouteConfigRules from '../components/deliveryRoutes/DeliveryRouteConfigRules';
import deliveryRoutes from '../api/deliveryRoutes';
import IdParamMixin from '../mixins/id-param';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { DeliveryRouteConfigRules },
    data() {
        return {
            routeId: '',
            name: '',
            description: '',
            configRules: null,
        };
    },
    mixins: [IdParamMixin(), localization],
    methods: {
        load() {
            this.routeId = '';
            this.name = '';
            this.description = '';
            this.configRules = null;
            const routeId = this.$route.params.id;

            this.$store.commit('general/setPageTitle', this.trans('pages.edit_delivery_route.title', { routeId }), {
                root: true,
            });

            deliveryRoutes.fetchRoute(routeId).then((response) => {
                const route = response.data.data;
                this.routeId = route.id;
                this.name = route.name;
                this.description = route.description;
                route.configRules.forEach((x) => {
                    x.removed = false;
                });
                this.configRules = route.configRules;
            });
        },
        editDeliveryRoute() {
            const routeId = this.routeId;
            const name = this.name;
            const description = this.description;
            const configRules = this.configRules;

            if (!name || name.length <= 0) {
                return showErrorMessage(this.trans('pages.edit_delivery_route.error_empty_name'));
            }

            deliveryRoutes
                .updateRoute(routeId, name, description, configRules)
                .then(() => {
                    this.$router.push('/deliveryroutes');
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.edit_delivery_route.error_save'));
                });
        },
    },
};
</script>
